import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Link,useHistory } from 'react-router-dom';
import useSetState from '../../../../hooks/useSetState';
import { enumHelper, validator, formatter } from '../../../../utils';
import ENUMS from '../../../../enums';
import {
  createRseePackageRequest,
  editRseePackageRequest
} from '../../../../redux/rseePackages/actions';

const AddOrEditPackage = props => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [controls, setControls] = useSetState({
    packageName: '',
    packageChairs: '',
    packagePrice: '',
    isActive: 'ACTIVE',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const onChangePackageChaires = (e) => {
    e.preventDefault();
    let { value } = e.target;

    if (
      !value ||
      (validator.isNumber(value.replaceAll(',', '')) &&
        value.replaceAll(',', '') < 1000000)
    ) {
      const val = new Intl.NumberFormat().format(value.replaceAll(',', ''));
      onChangeValue('packageChairs', val)
    }
  };

  const onChangePackagePrice = (e) => {
    e.preventDefault();
    let { value } = e.target;

    const val = new Intl.NumberFormat().format(value.replaceAll(',', ''));
    onChangeValue('packagePrice', val)
  };

  const onSubmit = e => {
    e.preventDefault();

    let standardChairs = Number(formatter.toStandard(
      controls.packageChairs.replaceAll(',', '')));

    let standardPrice = Number(formatter.toStandard(
      controls.packagePrice.replaceAll(',', '')));

    let data = {
      name: controls.packageName,
      numberOfRsee: standardChairs,
      price: standardPrice,
      status: controls.isActive,
    };

    if (props.location.editMode) {
      data = {
        ...data,
        id: props.location.item.id,
      };
      dispatch(editRseePackageRequest(data))
        .then(() => {
          history.push('/packages/management');
        })
        .catch(error => console.log('error', error));
    } else {
      dispatch(createRseePackageRequest(data))
        .then(() => {
          history.push('/packages/management');
        })
        .catch(error => console.log('error', error));
    };
  };

  useEffect(() => {
    if (props.location.editMode) {
      onChangeValue('packageName', props.location.item.name);
      onChangeValue('packageChairs', props.location.item.numberOfRsee.toString());
      const val = new Intl.NumberFormat().format(
        props.location.item.price.toString().replaceAll(',', ''));

      onChangeValue('packagePrice', val);
      onChangeValue('isActive', props.location.item.status);
    };
  }, []);

  return (
    <>
      <section className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-right text-muted py-4'>
          {locales('packages.management')}
        </h3>
        <div className='form-actions'>
          <button
            type='submit'
            form='addOrEditForm'
            className='btn btn-success px-2 mx-3'
          >
            <i className='fa fa-save' />
            {locales('labels.save')}
          </button>
          <Link to='/packages/management' className='btn btn-default'>
            <i className='fa fa-reply' />
            {locales('label.cancel')}
          </Link>
        </div>
      </section>

      <section className='panel panel-default'>
        <div className='panel-heading'>
          <h3 className='panel-title'>
            <i className='fa fa-pencil' />
            {props.location.editMode
              ? locales('edit.package')
              : locales('add.new.package')}
          </h3>
        </div>

        <div className='panel-body'>
          <form className='col form-horizontal' onSubmit={onSubmit} id='addOrEditForm'>
            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-2 text-right'>
                  {locales('package.name')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      className='form-control full-width'
                      type='text'
                      name='packageName'
                      id={'packageName'}
                      value={controls.packageName}
                      onChange={e => onChangeValue('packageName', e.target.value)}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-2 text-right'>
                  {locales('tables.totalChairs')}
                </label>
                <div className='full-width'>
                  <div className='full-width d-flex justify-content-start'>
                    <input
                      className='form-control full-width'
                      type='text'
                      name='packageChairs'
                      id={'packageChairs'}
                      value={controls.packageChairs}
                      onChange={e => onChangePackageChaires(e)}

                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label
                  className='rsee-form-label col-2 text-right'
                  htmlFor='packagePrice'
                >
                  {locales('package.price')}
                </label>
                <div className='full-width'>
                  <div className='input-group'>
                    <div className='input-group-prepend'>
                      <div className='input-group-text'>
                        {enumHelper.convertEnumValueToTitle(
                          ENUMS.CURRENCY.list,
                          'TOMAN',
                        )}
                      </div>
                    </div>
                    <input
                      id='packagePrice'
                      name='packagePrice'
                      type='text'
                      className={`form-control full-width'}`}
                      onChange={e => onChangePackagePrice(e)}
                      autoComplete='off'
                      value={controls.packagePrice.toLocaleString()}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col-lg-8 col-md-12 col-sm-12 d-flex required'>
                <label className='rsee-form-label col-2 text-right'>
                  {locales('package.status')}
                </label>
                <div className='form-group d-flex'>
                  {ENUMS.PACKAGE_STATUS.list.map((status) =>
                    <div className='form-check' key={status.value}>
                      <label className='form-check-label'>
                        {status.title}
                      </label>
                      <input
                        type='radio'
                        className='form-check-input'
                        value={status.value}
                        checked={controls.isActive === status.value}
                        onChange={e => onChangeValue('isActive', e.target.value)
                        }
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>)
};

export default AddOrEditPackage;